import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';
import { Permission } from '~/types/Permission';
import { User } from '~/types/User';

import { checkIsSuperAdmin } from '../checkIsSuperAdmin';
import { and } from '../utils/and';

export const checkIsRbac: Permission = and([
  () => useFlag(FlagType.NewUsersPage),
  (user: User) => !checkIsSuperAdmin(user),
]);
